// GENERATED by z-scripts/refresh-schools.js — do not edit by hand.
// MOE schools come from the data.gov.sg School Directory; international
// schools and preschool brands are curated in the script. Regenerate with:
//   node z-scripts/refresh-schools.js
// Generated: 2026-07-19

export const schools = [
    {
        name: "Admiralty Primary School",
        aliases: []
    },
    {
        name: "Ahmad Ibrahim Primary School",
        aliases: []
    },
    {
        name: "Ai Tong School",
        aliases: []
    },
    {
        name: "Alexandra Primary School",
        aliases: []
    },
    {
        name: "Anchor Green Primary School",
        aliases: []
    },
    {
        name: "Anderson Primary School",
        aliases: []
    },
    {
        name: "Ang Mo Kio Primary School",
        aliases: []
    },
    {
        name: "Anglo-Chinese School (International) Singapore",
        aliases: [
            "ACS International"
        ]
    },
    {
        name: "Anglo-Chinese School (Junior)",
        aliases: [
            "ACS Junior"
        ]
    },
    {
        name: "Anglo-Chinese School (Primary)",
        aliases: [
            "ACS Primary"
        ]
    },
    {
        name: "Angsana Primary School",
        aliases: []
    },
    {
        name: "Australian International School Singapore",
        aliases: [
            "AIS"
        ]
    },
    {
        name: "Beacon Primary School",
        aliases: []
    },
    {
        name: "Bedok Green Primary School",
        aliases: []
    },
    {
        name: "Bendemeer Primary School",
        aliases: []
    },
    {
        name: "Blangah Rise Primary School",
        aliases: []
    },
    {
        name: "Boon Lay Garden Primary School",
        aliases: []
    },
    {
        name: "Brighton College (Singapore)",
        aliases: [
            "Brighton"
        ]
    },
    {
        name: "Brighton Montessori",
        aliases: []
    },
    {
        name: "Bukit Panjang Primary School",
        aliases: []
    },
    {
        name: "Bukit Timah Primary School",
        aliases: []
    },
    {
        name: "Bukit View Primary School",
        aliases: []
    },
    {
        name: "Cambridge Pre-School",
        aliases: []
    },
    {
        name: "Canadian International School (Singapore)",
        aliases: [
            "CIS"
        ]
    },
    {
        name: "Canberra Primary School",
        aliases: []
    },
    {
        name: "Canossa Catholic Primary School",
        aliases: []
    },
    {
        name: "Cantonment Primary School",
        aliases: []
    },
    {
        name: "Carpe Diem Preschool",
        aliases: []
    },
    {
        name: "Casuarina Primary School",
        aliases: []
    },
    {
        name: "Catholic High School",
        aliases: [
            "CHS"
        ]
    },
    {
        name: "Cedar Primary School",
        aliases: []
    },
    {
        name: "Changkat Primary School",
        aliases: []
    },
    {
        name: "Chatsworth International School",
        aliases: []
    },
    {
        name: "CHIJ (Katong) Primary",
        aliases: []
    },
    {
        name: "CHIJ (Kellock)",
        aliases: []
    },
    {
        name: "CHIJ Our Lady of Good Counsel",
        aliases: []
    },
    {
        name: "CHIJ Our Lady of the Nativity",
        aliases: []
    },
    {
        name: "CHIJ Our Lady Queen of Peace",
        aliases: []
    },
    {
        name: "CHIJ Primary (Toa Payoh)",
        aliases: []
    },
    {
        name: "CHIJ St. Nicholas Girls' School",
        aliases: []
    },
    {
        name: "Chiltern House Preschool",
        aliases: []
    },
    {
        name: "Chongfu School",
        aliases: []
    },
    {
        name: "Chongzheng Primary School",
        aliases: []
    },
    {
        name: "Chua Chu Kang Primary School",
        aliases: []
    },
    {
        name: "Clementi Primary School",
        aliases: []
    },
    {
        name: "Compassvale Primary School",
        aliases: []
    },
    {
        name: "Concord Primary School",
        aliases: []
    },
    {
        name: "Corporation Primary School",
        aliases: []
    },
    {
        name: "Damai Primary School",
        aliases: []
    },
    {
        name: "Dazhong Primary School",
        aliases: []
    },
    {
        name: "De La Salle School",
        aliases: []
    },
    {
        name: "Dover Court International School",
        aliases: [
            "DCIS"
        ]
    },
    {
        name: "Dulwich College (Singapore)",
        aliases: [
            "DCSG"
        ]
    },
    {
        name: "E-Bridge Pre-School",
        aliases: []
    },
    {
        name: "East Spring Primary School",
        aliases: []
    },
    {
        name: "Edgefield Primary School",
        aliases: []
    },
    {
        name: "Elias Park Primary School",
        aliases: []
    },
    {
        name: "Endeavour Primary School",
        aliases: []
    },
    {
        name: "EtonHouse International School",
        aliases: [
            "Eton House"
        ]
    },
    {
        name: "EtonHouse Pre-School",
        aliases: []
    },
    {
        name: "Evergreen Primary School",
        aliases: []
    },
    {
        name: "Fairfield Methodist School (Primary)",
        aliases: []
    },
    {
        name: "Farrer Park Primary School",
        aliases: []
    },
    {
        name: "Fengshan Primary School",
        aliases: []
    },
    {
        name: "Fern Green Primary School",
        aliases: []
    },
    {
        name: "Fernvale Primary School",
        aliases: []
    },
    {
        name: "First Toa Payoh Primary School",
        aliases: []
    },
    {
        name: "Frontier Primary School",
        aliases: []
    },
    {
        name: "Fuchun Primary School",
        aliases: []
    },
    {
        name: "Fuhua Primary School",
        aliases: []
    },
    {
        name: "Gan Eng Seng Primary School",
        aliases: []
    },
    {
        name: "GEMS World Academy (Singapore)",
        aliases: [
            "GEMS"
        ]
    },
    {
        name: "German European School Singapore",
        aliases: [
            "GESS"
        ]
    },
    {
        name: "Geylang Methodist School (Primary)",
        aliases: []
    },
    {
        name: "Global Indian International School Singapore",
        aliases: [
            "GIIS"
        ]
    },
    {
        name: "Gongshang Primary School",
        aliases: []
    },
    {
        name: "Greendale Primary School",
        aliases: []
    },
    {
        name: "Greenridge Primary School",
        aliases: []
    },
    {
        name: "Greenwood Primary School",
        aliases: []
    },
    {
        name: "Haig Girls' School",
        aliases: []
    },
    {
        name: "Henry Park Primary School",
        aliases: []
    },
    {
        name: "Holland International School",
        aliases: []
    },
    {
        name: "Holy Innocents' Primary School",
        aliases: []
    },
    {
        name: "Hong Wen School",
        aliases: []
    },
    {
        name: "Horizon Primary School",
        aliases: []
    },
    {
        name: "Hougang Primary School",
        aliases: []
    },
    {
        name: "Huamin Primary School",
        aliases: []
    },
    {
        name: "Hwa Chong International School",
        aliases: [
            "HCIS"
        ]
    },
    {
        name: "Innova Primary School",
        aliases: []
    },
    {
        name: "International Community School (Singapore)",
        aliases: [
            "ICS"
        ]
    },
    {
        name: "International French School (Singapore)",
        aliases: [
            "IFS",
            "French School",
            "Lycée Français"
        ]
    },
    {
        name: "Invictus International School",
        aliases: []
    },
    {
        name: "ISS International School",
        aliases: [
            "ISS"
        ]
    },
    {
        name: "Jiemin Primary School",
        aliases: []
    },
    {
        name: "Jing Shan Primary School",
        aliases: []
    },
    {
        name: "Josiah Montessori",
        aliases: []
    },
    {
        name: "Junyuan Primary School",
        aliases: []
    },
    {
        name: "Jurong Primary School",
        aliases: []
    },
    {
        name: "Jurong West Primary School",
        aliases: []
    },
    {
        name: "Keming Primary School",
        aliases: []
    },
    {
        name: "Kheng Cheng School",
        aliases: []
    },
    {
        name: "Kiddiwinkie Schoolhouse",
        aliases: []
    },
    {
        name: "Kinderland Preschool",
        aliases: []
    },
    {
        name: "Kong Hwa School",
        aliases: []
    },
    {
        name: "Kranji Primary School",
        aliases: []
    },
    {
        name: "Kuo Chuan Presbyterian Primary School",
        aliases: []
    },
    {
        name: "Lakeside Primary School",
        aliases: []
    },
    {
        name: "Learning Vision",
        aliases: []
    },
    {
        name: "Lianhua Primary School",
        aliases: []
    },
    {
        name: "Little Seeds Preschool",
        aliases: []
    },
    {
        name: "Maha Bodhi School",
        aliases: []
    },
    {
        name: "Maple Bear Singapore",
        aliases: [
            "Maplebear"
        ]
    },
    {
        name: "Maris Stella High School",
        aliases: []
    },
    {
        name: "Marsiling Primary School",
        aliases: []
    },
    {
        name: "Marymount Convent School",
        aliases: []
    },
    {
        name: "Mayflower Primary School",
        aliases: []
    },
    {
        name: "Mee Toh School",
        aliases: []
    },
    {
        name: "Meridian Primary School",
        aliases: []
    },
    {
        name: "Methodist Girls' School (Primary)",
        aliases: [
            "MGS"
        ]
    },
    {
        name: "Middleton International School",
        aliases: []
    },
    {
        name: "MindChamps PreSchool",
        aliases: []
    },
    {
        name: "MOE Kindergarten",
        aliases: [
            "MK"
        ]
    },
    {
        name: "Montfort Junior School",
        aliases: []
    },
    {
        name: "My First Skool",
        aliases: []
    },
    {
        name: "Nan Chiau Primary School",
        aliases: []
    },
    {
        name: "Nan Hua Primary School",
        aliases: []
    },
    {
        name: "Nanyang Kindergarten",
        aliases: []
    },
    {
        name: "Nanyang Primary School",
        aliases: [
            "NYPS"
        ]
    },
    {
        name: "Naval Base Primary School",
        aliases: []
    },
    {
        name: "New Town Primary School",
        aliases: []
    },
    {
        name: "Nexus International School Singapore",
        aliases: []
    },
    {
        name: "Ngee Ann Primary School",
        aliases: []
    },
    {
        name: "North London Collegiate School (Singapore)",
        aliases: [
            "NLCS"
        ]
    },
    {
        name: "North Spring Primary School",
        aliases: []
    },
    {
        name: "North View Primary School",
        aliases: []
    },
    {
        name: "North Vista Primary School",
        aliases: []
    },
    {
        name: "Northland Primary School",
        aliases: []
    },
    {
        name: "Northoaks Primary School",
        aliases: []
    },
    {
        name: "Northshore Primary School",
        aliases: []
    },
    {
        name: "Oasis Primary School",
        aliases: []
    },
    {
        name: "One World International School",
        aliases: [
            "OWIS"
        ]
    },
    {
        name: "Opera Estate Primary School",
        aliases: []
    },
    {
        name: "Overseas Family School",
        aliases: [
            "OFS"
        ]
    },
    {
        name: "Palm View Primary School",
        aliases: []
    },
    {
        name: "Park View Primary School",
        aliases: []
    },
    {
        name: "Pasir Ris Primary School",
        aliases: []
    },
    {
        name: "Pat's Schoolhouse",
        aliases: []
    },
    {
        name: "Paya Lebar Methodist Girls' School (Primary)",
        aliases: []
    },
    {
        name: "PCF Sparkletots Preschool",
        aliases: [
            "PCF",
            "Sparkletots"
        ]
    },
    {
        name: "Pei Chun Public School",
        aliases: []
    },
    {
        name: "Pei Hwa Presbyterian Primary School",
        aliases: []
    },
    {
        name: "Pei Tong Primary School",
        aliases: []
    },
    {
        name: "Peiying Primary School",
        aliases: []
    },
    {
        name: "Pioneer Primary School",
        aliases: []
    },
    {
        name: "Poi Ching School",
        aliases: []
    },
    {
        name: "Princess Elizabeth Primary School",
        aliases: []
    },
    {
        name: "Punggol Cove Primary School",
        aliases: []
    },
    {
        name: "Punggol Green Primary School",
        aliases: []
    },
    {
        name: "Punggol Primary School",
        aliases: []
    },
    {
        name: "Punggol View Primary School",
        aliases: []
    },
    {
        name: "Qifa Primary School",
        aliases: []
    },
    {
        name: "Qihua Primary School",
        aliases: []
    },
    {
        name: "Queenstown Primary School",
        aliases: []
    },
    {
        name: "Radin Mas Primary School",
        aliases: []
    },
    {
        name: "Raffles Girls' Primary School",
        aliases: [
            "RGPS"
        ]
    },
    {
        name: "Red Swastika School",
        aliases: []
    },
    {
        name: "River Valley Primary School",
        aliases: []
    },
    {
        name: "Riverside Primary School",
        aliases: []
    },
    {
        name: "Rivervale Primary School",
        aliases: []
    },
    {
        name: "Rosyth School",
        aliases: []
    },
    {
        name: "Rulang Primary School",
        aliases: []
    },
    {
        name: "Safari House Preschool",
        aliases: []
    },
    {
        name: "Sembawang Primary School",
        aliases: []
    },
    {
        name: "Seng Kang Primary School",
        aliases: []
    },
    {
        name: "Sengkang Green Primary School",
        aliases: []
    },
    {
        name: "Shuqun Primary School",
        aliases: []
    },
    {
        name: "Si Ling Primary School",
        aliases: []
    },
    {
        name: "Singapore American School",
        aliases: [
            "SAS"
        ]
    },
    {
        name: "Singapore Chinese Girls' Primary School",
        aliases: [
            "SCGS"
        ]
    },
    {
        name: "Singapore Korean International School",
        aliases: [
            "SKIS"
        ]
    },
    {
        name: "SJI International School",
        aliases: [
            "SJII",
            "St Joseph International"
        ]
    },
    {
        name: "Skool4Kidz",
        aliases: []
    },
    {
        name: "South View Primary School",
        aliases: []
    },
    {
        name: "Springdale Primary School",
        aliases: []
    },
    {
        name: "St Andrew's School (Junior)",
        aliases: []
    },
    {
        name: "St. Anthony's Canossian Primary School",
        aliases: []
    },
    {
        name: "St. Anthony's Primary School",
        aliases: []
    },
    {
        name: "St. Gabriel's Primary School",
        aliases: []
    },
    {
        name: "St. Hilda's Primary School",
        aliases: [
            "SHPS"
        ]
    },
    {
        name: "St. James' Church Kindergarten",
        aliases: []
    },
    {
        name: "St. Joseph Institution International Elementary School",
        aliases: []
    },
    {
        name: "St. Joseph's Institution Junior",
        aliases: []
    },
    {
        name: "St. Margaret's School (Primary)",
        aliases: []
    },
    {
        name: "St. Stephen's School",
        aliases: []
    },
    {
        name: "Stamford American International School",
        aliases: [
            "SAIS"
        ]
    },
    {
        name: "Star Learners Child Care",
        aliases: []
    },
    {
        name: "Superland Pre-School",
        aliases: []
    },
    {
        name: "Swiss School in Singapore",
        aliases: []
    },
    {
        name: "Tampines North Primary School",
        aliases: []
    },
    {
        name: "Tampines Primary School",
        aliases: []
    },
    {
        name: "Tanglin Trust School",
        aliases: [
            "TTS"
        ]
    },
    {
        name: "Tanjong Katong Primary School",
        aliases: [
            "TKPS"
        ]
    },
    {
        name: "Tao Nan School",
        aliases: [
            "TNS"
        ]
    },
    {
        name: "Teck Ghee Primary School",
        aliases: []
    },
    {
        name: "Teck Whye Primary School",
        aliases: []
    },
    {
        name: "Telok Kurau Primary School",
        aliases: []
    },
    {
        name: "Temasek Primary School",
        aliases: []
    },
    {
        name: "The Japanese School Singapore",
        aliases: []
    },
    {
        name: "The Little Skool-House",
        aliases: []
    },
    {
        name: "The Odyssey Global Preschool",
        aliases: [
            "Odyssey"
        ]
    },
    {
        name: "The Perse School Singapore",
        aliases: []
    },
    {
        name: "Townsville Primary School",
        aliases: []
    },
    {
        name: "United World College of South East Asia",
        aliases: [
            "UWC",
            "UWCSEA"
        ]
    },
    {
        name: "Unity Primary School",
        aliases: []
    },
    {
        name: "Valour Primary School",
        aliases: []
    },
    {
        name: "Waseda Shibuya Senior High School in Singapore",
        aliases: []
    },
    {
        name: "Waterway Primary School",
        aliases: []
    },
    {
        name: "Wellington Primary School",
        aliases: []
    },
    {
        name: "West Grove Primary School",
        aliases: []
    },
    {
        name: "West Spring Primary School",
        aliases: []
    },
    {
        name: "West View Primary School",
        aliases: []
    },
    {
        name: "Westwood Primary School",
        aliases: []
    },
    {
        name: "White Lodge Preschool",
        aliases: []
    },
    {
        name: "White Sands Primary School",
        aliases: []
    },
    {
        name: "Woodgrove Primary School",
        aliases: []
    },
    {
        name: "Woodlands Primary School",
        aliases: []
    },
    {
        name: "Woodlands Ring Primary School",
        aliases: []
    },
    {
        name: "XCL World Academy",
        aliases: [
            "XCL"
        ]
    },
    {
        name: "Xinghua Primary School",
        aliases: []
    },
    {
        name: "Xingnan Primary School",
        aliases: []
    },
    {
        name: "Xinmin Primary School",
        aliases: []
    },
    {
        name: "Xishan Primary School",
        aliases: []
    },
    {
        name: "Yangzheng Primary School",
        aliases: []
    },
    {
        name: "Yew Tee Primary School",
        aliases: []
    },
    {
        name: "Yio Chu Kang Primary School",
        aliases: []
    },
    {
        name: "Yishun Primary School",
        aliases: []
    },
    {
        name: "Yu Neng Primary School",
        aliases: []
    },
    {
        name: "Yuhua Primary School",
        aliases: []
    },
    {
        name: "Yumin Primary School",
        aliases: []
    },
    {
        name: "Zhangde Primary School",
        aliases: []
    },
    {
        name: "Zhenghua Primary School",
        aliases: []
    },
    {
        name: "Zhonghua Primary School",
        aliases: []
    },
    {
        name: "Not in school yet",
        aliases: [
            "none",
            "n/a",
            "not applicable"
        ]
    },
    {
        name: "Homeschooled",
        aliases: []
    }
];
